module.exports = __webpack_public_path__ + "img/tez2017-min.7c855ddf.jpg";